/** Foot attachment scale and ankle origin determine its distance above the sole. */
export function ankleForSole(soleY:number,imageWidth:number,imageHeight:number,displayWidth:number,originY:number):number {
  return soleY-imageHeight*displayWidth/Math.max(1,imageWidth)*(1-originY);
}
export const FOOT_ORIGINS={front:{x:.28,y:.14},back:{x:.28,y:.55}} as const;

/** Convert the rendered owner's air gap to rig space so its pet shadow stays on ground. */
export function companionGroundY(renderedAirGap:number,rigScale:number):number {
  return Math.max(0,renderedAirGap)/Math.max(.001,Math.abs(rigScale));
}
